import { useId } from "react";

import classes from "./SoundWave.module.css";

// Twelve rounded bars, tall in the middle of each half, as live's sound tiles draw a sound. The
// heights are ours; the look (thin bars on the accent gradient) is live's.
const HEIGHTS = [10, 26, 42, 26, 8, 30, 44, 28, 12, 20, 36, 6];
const WIDTH = 72;
const HEIGHT = 46;
const BAR = 2.5;
const GAP = (WIDTH - BAR * HEIGHTS.length) / (HEIGHTS.length - 1);

export interface SoundWaveProps {
  className?: string | undefined;
  /** The sound is playing: the bars bounce. */
  animated?: boolean;
}

/** A sound's picture on the accent gradient, as live's audio tiles show one. Decoration. */
export function SoundWave({ className, animated = false }: SoundWaveProps) {
  const gradient = useId();
  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      fill="none"
      className={[classes.wave, className].filter(Boolean).join(" ")}
      data-animated={animated || undefined}
      aria-hidden
    >
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="0">
          <stop className={classes.from} />
          <stop offset="1" className={classes.to} />
        </linearGradient>
      </defs>
      {HEIGHTS.map((height, index) => (
        <rect
          key={index}
          className={classes.bar}
          x={index * (BAR + GAP)}
          y={(HEIGHT - height) / 2}
          width={BAR}
          height={height}
          rx={BAR / 2}
          fill={`url(#${gradient})`}
        />
      ))}
    </svg>
  );
}
